function offset(el) {
    let rect = el.getBoundingClientRect(),
        scrollLeft = window.scrollX || document.documentElement.scrollLeft,
        scrollTop = window.scrollY || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
let menuPosition = offset(document.querySelector('#js-NavMain'));

if(window.innerWidth > 960){
    window.addEventListener('scroll', function() {
        if(window.scrollY > menuPosition.top){
            document.getElementById('header').classList.add('header--fixed');
        }
        else{
            document.getElementById('header').classList.remove('header--fixed');
        }
    })
}

//================================================
// sticky en un clic
//================================================

const sticky = document.querySelector('.js-access-sticky');

if (sticky) {
    const openSticky = document.querySelector('.js-access-sticky__button--open');
    const closeSticky = document.querySelector('.js-access-sticky__button--close');

    //if (sticky.classList.contains('js-active-stick')) {
        document.addEventListener('click', event => {
            if (event.target != openSticky) {
                if (sticky.classList.contains('js-active-sticky')) {
                    sticky.closest('.header').querySelector('.js-access-sticky').classList.remove('js-active-sticky');
                }
            }
        })
    //}
    
    // Open stick
    openSticky.addEventListener('click', function () {
        sticky.classList.add('js-active-sticky');
    });
    // Close stick
    closeSticky.addEventListener('click', function () {
        sticky.classList.remove('js-active-sticky');
    });





}

